import React, { Component } from 'react';

import {
    Row,
    Col,
    Table,
    FormGroup, Label, Input
} from 'reactstrap';

import ReactPaginate from 'react-paginate';
import moment from 'moment';
import { Player, Controls } from "@lottiefiles/react-lottie-player";
import Isvg from 'react-inlinesvg';
import sortDown from '../assets/sortdown.svg';
import sortUp from '../assets/sortup.svg';

import env from "react-dotenv";
import noImage from '../assets/no-image.png';
import {API_ENDPOINT, CDN_URL} from '../constants';

/**
* Generate data list with pagination
* @author   Milan Stanojevic
*/
class ListBuilder extends Component {
    constructor(props) {
        super(props);

        this.state = {
            filter: props.params && props.params.filter ? props.params.filter : '',
        };

        this.filterTimer = null;
    }

    componentDidMount() {

    }

    componentDidUpdate(prevProps) {
        let prevFilter = prevProps.params ? prevProps.params.filter : undefined;
        let filter = this.props.params ? this.props.params.filter : undefined;

        // keep the input in sync when the filter is changed from the outside (tab change, reset, back navigation),
        // but never while the user is still typing
        if (prevFilter != filter && filter != this.state.filter && !this.filterTimer) {
            this.setState({ filter: filter ? filter : '' })
        }
    }

    componentWillUnmount() {
        if (this.filterTimer) {
            clearTimeout(this.filterTimer);
            this.filterTimer = null;
        }
    }

    /**
    * Update search input immediately, but wait for the user to stop typing before querying the API
    */
    updateFilter = (value) => {
        this.setState({ filter: value });

        if (this.filterTimer) {
            clearTimeout(this.filterTimer);
            this.filterTimer = null;
        }

        let delay = typeof this.props.searchDebounce != 'undefined' ? this.props.searchDebounce : 300;

        if (!delay) {
            this.props.updateMultipleParams([{ name: 'filter', value: value }, { name: 'page', value: 0 }], true);
            return;
        }

        this.filterTimer = setTimeout(() => {
            this.filterTimer = null;
            this.props.updateMultipleParams([{ name: 'filter', value: value }, { name: 'page', value: 0 }], true);
        }, delay);
    }

    render() {
        let params = this.props.params;
        console.log(this.props)
        return (
            <Row className="list-builder-wrap">
                        <Col lg="7">
                            
                            {
                                this.props.tabs ? 
                                    <div className="table-tabs">
                                        <button className={!this.props.tab2Active && !this.props.tab3Active  && !this.props.tab4Active ? 'active' : ''} onClick={() => this.props.onClickTab1()}>{this.props.tab1Name}</button>
                                        {this.props.tab2Name ? <button className={this.props.tab2Active ? 'active' : ''} onClick={() => this.props.onClickTab2()}>{this.props.tab2Name}</button> : null }
                                        {
                                            this.props.tab3Name ?
                                            <button className={this.props.tab3Active ? 'active' : ''} onClick={() => this.props.onClickTab3()}>{this.props.tab3Name}</button>

                                            :
                                            null
                                        }
                                                                                {
                                            this.props.tab4Name ?
                                            <button className={this.props.tab4Active ? 'active' : ''} onClick={() => this.props.onClickTab4()}>{this.props.tab4Name}</button>

                                            :
                                            null
                                        }

                                    </div>
                                :
                                null
                            }
                        </Col>

                        
                        {
                            this.props.sort ?

                            <Col lg="5" style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
                                <FormGroup className="table-filter">
                                    {
                                        this.props.additionalFilterFields ?
                                        this.props.additionalFilterFields 
                                        :
                                        null
                                    }

                                    {
                                        !this.props.hideResults ?
                                        <Label>
                                            <Input style={{minWidth: 62}} type="select" className="entries" value={params.entries} onChange={(e) => this.props.updateMultipleParams([{ name: 'entries', value: e.target.value }, { name: 'page', value: 0 }], true)}>
                                                <option value={10}>10</option>
                                                <option value={25}>25</option>
                                                <option value={50}>50</option>
                                                <option value={100}>100</option>
                                            </Input>
                                            {'results per page'.translate(this.props.lang)}
                                        </Label>
                                        :
                                        null
                                    }

                                    
                                    
                                    {
                                        !this.props.hideFilters ?

                                        <div className="filter-results">
                                            <FormGroup>
                                                <Label> <Input type="text" placeholder="Search..." style={{ marginRight: 0 }} value={this.state.filter} onChange={(e) => this.updateFilter(e.target.value)} ></Input></Label>
                                            </FormGroup>
                                        </div>
                                        :
                                        null
                                    }
                                </FormGroup>
                            </Col>
                        
                        :
                            !this.props.hideFilters ?
                            <Col lg="12">
                                <div className="list-header">
                                <Label>
                                    {this.props.header}
                                </Label>
                            

                                <div className="filter-results">
                                    <FormGroup>
                                        <Label> <Input type="text" placeholder="Search" style={{ marginRight: 0 }} value={this.state.filter} onChange={(e) => this.updateFilter(e.target.value)} ></Input></Label>
                                    </FormGroup>
                                </div>
                                </div>
                            </Col>
                        : 
                        null
                        }

                       
                        

                <Col lg="12" className="table-container">
                    <div className="table-container-scroll">
                        <Table responsive hover className={!this.props.actions ? 'cursor-row' : ''}>
                            <thead>
                                <tr style={{ whiteSpace: 'nowrap' }}>
                                    {this.props.showNumeration ? <th>#</th> : null}

                                    {
                                        this.props.fields.map((item, idx) => {
                                            return (
                                                <th  className={item.allowSort ? 'sort-enabled' : null} title={item.title} onClick={() => {
                                                    if (item.allowSort) {
                                                        this.props.updateSort(item.name, !this.props.sortField ? 1 : this.props.sortField == item.name && parseInt(this.props.sortType) == 1 ? -1 : 1)
                                                    }
                                                }} key={idx}>{item.label} {item.allowSort ? <span className={this.props.sortField == item.name && parseInt(this.props.sortType) == 1 ? `sort sort-asc` : this.props.sortField == item.name && parseInt(this.props.sortType) == -1 ? 'sort sort-desc' : item.allowSort ? 'sort' : ''}><Isvg src={sortUp} className="sort-up-icon" /><Isvg src={sortDown} className="sort-down-icon" /></span> : null}</th>
                                            )
                                        })
                                    }
                                    {this.props.actions ?
                                        <th className="action-td">{/*{this.props.actionLabel ? this.props.actionLabel : 'Action'.translate(this.props.lang)}*/}</th>
                                        :
                                        null}
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    this.props.items && this.props.items.length ? this.props.items.map((item, idx) => {
                                        return (
                                            <tr key={idx} onClick={() => {
                                                if (!this.props.actions && this.props.onClick) {
                                                    if (this.props.rawItems)
                                                        this.props.onClick(this.props.rawItems[idx])
                                                    else
                                                        this.props.onClick(item)
                                                }
                                            }}>
                                                {this.props.showNumeration ? <th scope="row">{params.page * params.entries + idx + 1}</th> : null}
                                                {
                                                    this.props.fields.map((field, fidx) => {
                                                        if (field.type == 'two-rows-text') {
                                                            return (
                                                                <td key={fidx}>
                                                                    {
                                                                        field.strong && field.strong(item) ?
                                                                            <>
                                                                                <strong> {field.beforeText && field.beforeText.condition(item) ? field.beforeText.text : ''}  {field.multilang ? Object.translate(item, field.name, this.props.lang) : Object.get(item, field.name)}</strong> <br /><span className="clinic-subgroup-name">{Object.get(item, field.secondRowName)}</span>
                                                                            </>
                                                                            :
                                                                            <>
                                                                                {field.beforeText && field.beforeText.condition(item) ? field.beforeText.text : ''} {field.multilang ? Object.translate(item, field.name, this.props.lang) : Object.get(item, field.name)} <br /><span className="clinic-subgroup-name">{Object.get(item, field.secondRowName)}</span>

                                                                            </>
                                                                    }

                                                                </td>
                                                            )
                                                        }else if (field.type == 'image') {
                                                            return (
                                                                <td key={fidx} style={{maxWidth: field.maxWidth, overflow: field.maxWidth ? 'hidden' : 'unset', wordBreak: field.maxWidth ? 'break-all' : 'unset'}}>{<img className="image-field" src={item[field.name]?.bildbankId ? `${CDN_URL}/bb-derivatives/derivatives/${item[field.name].bildbankId}/thumb_w400.webp` : noImage} /> }</td>
                                                            )
                                                        } else if (field.type == 'text') {
                                                            let value = field.multilang ? item[field.name] && item[field.name][this.props.lang] : Object.get(item, field.name);
                                                            // truncate: keep the cell on one line, cut with an ellipsis and show the full text on hover
                                                            if (field.truncate) {
                                                                return (
                                                                    <td key={fidx} className="cell-truncate" style={{maxWidth: field.maxWidth || 200}} title={typeof value == 'string' || typeof value == 'number' ? value : undefined}>{value}</td>
                                                                )
                                                            }
                                                            return (
                                                                <td key={fidx} style={{maxWidth: field.maxWidth, overflow: field.maxWidth ? 'hidden' : 'unset', wordBreak: field.maxWidth ? 'break-all' : 'unset'}}>{value}</td>
                                                            )
                                                        }
                                                         /*else if (field.type == 'checkbox') {
                                                            return (
                                                                <td key={fidx}>
                                                                    <div>
                                                                        <Checkbox checked={item[field.name]} label={field.multilang ? item[field.name] && item[field.name][this.props.lang] : item[field.name]} />
                                                                    </div>
                                                                </td>
                                                            )
                                                        } */else if (field.type == 'list') {
                                                            return (
                                                                <td key={fidx}>
                                                                    {
                                                                        item[field.name] ? item[field.name].map((fitem, fitemidx) => {
                                                                            return (
                                                                                <div className="list-item">
                                                                                    {fitem[field.itemName]}

                                                                                    {
                                                                                        field.actions.map((action, aidx) => {
                                                                                            return (
                                                                                                <button key={aidx} onClick={() => action.onClick(item, fitemidx)}>{action.component}</button>
                                                                                            )
                                                                                        })

                                                                                    }
                                                                                </div>
                                                                            )
                                                                        })
                                                                            :
                                                                            null
                                                                    }
                                                                </td>
                                                            )

                                                        }
                                                    })
                                                }
                                                {this.props.actions ?
                                                    
                                                    <td className="action-td">
                                                        {
                                                            this.props.actions && this.props.actions.length ?
                                                                this.props.actions.map((action, aidx) => {
                                                                    if (!action.condition || (action.condition && action.condition(item)))
                                                                        return (
                                                                            <button key={aidx} onClick={() => {
                                                                                if (this.props.rawItems) {
                                                                                    action.onClick(this.props.rawItems[idx]);
                                                                                }
                                                                                else {
                                                                                    action.onClick(item)
                                                                                }
                                                                            }}>{action.component}</button>
                                                                        )
                                                                })
                                                                :
                                                                null
                                                        }
                                                    </td>
                                                    
                                                    :
                                                    null
                                                }



                                            </tr>
                                        )
                                    })
                                        :
                                        null

                                }
                            </tbody>
                        </Table>
                    </div>
                    {this.props.loading ?
                        <div className="loader-wrap" >
                            <Player
                                autoplay={true}
                                loop={true}
                                src="/lf30_editor_l5cxzdyf.json"
                                style={{ height: typeof window != 'undefined' && window.innerWidth < 768 ? "128px" : "256px", width: typeof window != 'undefined' && window.innerWidth < 768 ? "128px" : "256px" }}
                            ></Player>

                        </div>
                        :
                        null
                    }

                </Col>
                {
                    !this.props.hidePagination ?
                    <>
                    <Col lg="6">
                    <ReactPaginate
                        previousLabel={'<'}
                        nextLabel={'>'}
                        breakLabel={'...'}
                        breakClassName={'page-item disabled'}
                        breakLinkClassName={'page-link disabled'}
                        pageCount={this.props.total / params.entries}
                        marginPagesDisplayed={1}
                        pageRangeDisplayed={2}
                        onPageChange={(page) => { this.props.updateParams('page', page.selected) }}
                        containerClassName={'pagination'}
                        subContainerClassName={'pages pagination'}

                        pageClassName={'page-item'}
                        pageLinkClassName={'page-link'}
                        previousClassName={'page-item-next'}
                        previousLinkClassName={'page-link'}
                        nextClassName={'page-item-next'}
                        nextLinkClassName={'page-link'}
                        activeClassName={'active'}
                        forcePage={parseInt(params.page)}
                    />
                </Col>
                <Col lg="6">
                    <span className="news-counter" >{'Shows '.translate(this.props.lang)}  <span className="colored-green"> {this.props.total ? (params.page * params.entries + 1) : 0} </span> {'to'.translate(this.props.lang)} <span className="colored-green"> {this.props.total < (params.page * params.entries + params.entries * 1) ? this.props.total : (params.page * params.entries + params.entries * 1)} </span>  {'of'.translate(this.props.lang)} <span className="colored-blue"> {this.props.total} </span>  {'items'.translate(this.props.lang)}</span>
                </Col>
                    </>
                    :
                    null
                }
                
            </Row>

        );
    }
}

export default ListBuilder;